import { apiRequest } from '../utils/data';
import env from '../utils/env';

const GROWTH = {
  FETCH_USER_SUBSCRIPTIONS_REQUEST: 'growth/fetch_user_subscriptions_request',
  FETCH_USER_SUBSCRIPTIONS_SUCCESS: 'growth/fetch_user_subscriptions_success',
  FETCH_USER_SUBSCRIPTIONS_FAILURE: 'growth/fetch_user_subscriptions_failure',
  SELECT_PRODUCT_DETAIL: 'growth/select_product_detail',
  UNSELECT_PRODUCT_DETAIL: 'growth/unselect_product_detail',
  CANCEL_USER_SUBSCRIPTION_REQUEST: 'growth/cancel_user_subscription_request',
  CANCEL_USER_SUBSCRIPTION_SUCCESS: 'growth/cancel_user_subscription_success',
  CANCEL_USER_SUBSCRIPTION_FAILURE: 'growth/cancel_user_subscription_failure',
};

const initialState = {
  userSubscriptions: [],
  isLoading: false,
  error: null,
  selectedProduct: {},
  cancelingSubscriptionId: null,
  isCanceling: false,
  cancelError: null,
};

export const fetchUserSubscriptionsRequest = () => ({
  type: GROWTH.FETCH_USER_SUBSCRIPTIONS_REQUEST,
});

export const fetchUserSubscriptionsSuccess = (userSubscriptions) => ({
  type: GROWTH.FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  userSubscriptions,
});

export const fetchUserSubscriptionsFailure = (error) => ({
  type: GROWTH.FETCH_USER_SUBSCRIPTIONS_FAILURE,
  error,
});

export const selectProductDetail = (product) => ({
  type: GROWTH.SELECT_PRODUCT_DETAIL,
  product,
});

export const unselectProductDetail = () => ({
  type: GROWTH.UNSELECT_PRODUCT_DETAIL,
});

export const cancelUserSubscriptionRequest = (subscriptionUuid) => ({
  type: GROWTH.CANCEL_USER_SUBSCRIPTION_REQUEST,
  subscriptionUuid,
});

export const cancelUserSubscriptionSuccess = (subscriptionUuid) => ({
  type: GROWTH.CANCEL_USER_SUBSCRIPTION_SUCCESS,
  subscriptionUuid,
});

export const cancelUserSubscriptionFailure = (error) => ({
  type: GROWTH.CANCEL_USER_SUBSCRIPTION_FAILURE,
  error,
});

export const getUserSubscriptions = () => async (dispatch) => {
  dispatch(fetchUserSubscriptionsRequest());
  try {
    const response = await fetch(apiRequest('GET', `${env.growth}/v1/subscriptions/self`));
    if (response.status >= 300) {
      throw response.status;
    } else {
      const data = await response.json();
      dispatch(fetchUserSubscriptionsSuccess(data.subscriptions || []));
    }
  } catch (error) {
    dispatch(fetchUserSubscriptionsFailure(error));
  }
};

export const cancelUserSubscription = (subscriptionUuid) => async (dispatch) => {
  dispatch(cancelUserSubscriptionRequest(subscriptionUuid));
  try {
    const response = await fetch(
      apiRequest(
        'PATCH',
        `${env.growth}/v1/subscriptions/self/subscription-uuid/${subscriptionUuid}/cancel`,
      ),
    );
    if (response.status >= 300) {
      throw response.status;
    } else {
      dispatch(cancelUserSubscriptionSuccess(subscriptionUuid));
      dispatch(getUserSubscriptions());
    }
  } catch (error) {
    dispatch(cancelUserSubscriptionFailure(error));
  }
};

const growthReducer = (state = initialState, action) => {
  switch (action.type) {
    case GROWTH.FETCH_USER_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GROWTH.FETCH_USER_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userSubscriptions: action.userSubscriptions,
        error: null,
      };

    case GROWTH.FETCH_USER_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case GROWTH.SELECT_PRODUCT_DETAIL:
      return {
        ...state,
        selectedProduct: {
          ...action.product,
        },
      };

    case GROWTH.UNSELECT_PRODUCT_DETAIL:
      return {
        ...state,
        selectedProduct: {},
      };

    case GROWTH.CANCEL_USER_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        cancelingSubscriptionId: action.subscriptionUuid,
        isCanceling: true,
        cancelError: null,
      };

    case GROWTH.CANCEL_USER_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        cancelingSubscriptionId: null,
        isCanceling: false,
        cancelError: null,
        userSubscriptions: state.userSubscriptions.map((subscription) =>
          subscription.id === action.subscriptionUuid
            ? { ...subscription, cancelled: true, active: false }
            : subscription,
        ),
      };

    case GROWTH.CANCEL_USER_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        cancelingSubscriptionId: null,
        isCanceling: false,
        cancelError: action.error,
      };

    default:
      return state;
  }
};

export default growthReducer;
